import { triggerSimpleAjax } from "../../helpers/httpHelper";
import { OCR_INVOICE_API } from "../../helpers/constants/apiUrl";

const sendSingleDelete = (invoiceId, payload) => {
    return new Promise((res, rej) => {
        const url = `${OCR_INVOICE_API}${invoiceId}/delete-sku/`;
        triggerSimpleAjax(
            url,
            "POST",
            payload,
            (response) => {
                res(response);
            },
            (err) => {
                rej(err);
            }
        );
    });
};

const deleteOcrInvoiceSku = async (invoiceId, payload) => {
    if (!payload || typeof payload !== "object") {
        return Promise.resolve();
    }

    if (payload.row_index !== undefined) {
        const singleSkuId = Array.isArray(payload.sku_id) ? payload.sku_id[0] : payload.sku_id;
        if (singleSkuId !== undefined) {
            return sendSingleDelete(invoiceId, { sku_id: singleSkuId, row_index: payload.row_index });
        }
    }

    let addonSkuIds = Array.isArray(payload.addon_sku_id)
        ? [...payload.addon_sku_id]
        : payload.addon_sku_id !== undefined
        ? [payload.addon_sku_id]
        : [];

    let skuIds = Array.isArray(payload.sku_id)
        ? [...payload.sku_id]
        : payload.sku_id !== undefined
        ? [payload.sku_id]
        : [];

    const specificRowRequests = [];

    if (Array.isArray(payload.items)) {
        for (const item of payload.items) {
            if (item && typeof item === "object") {
                if (item.addon_sku_id !== undefined) {
                    if (Array.isArray(item.addon_sku_id)) {
                        addonSkuIds.push(...item.addon_sku_id);
                    } else {
                        addonSkuIds.push(item.addon_sku_id);
                    }
                } else if (item.row_index !== undefined) {
                    const sId = Array.isArray(item.sku_id) ? item.sku_id[0] : item.sku_id;
                    specificRowRequests.push(sendSingleDelete(invoiceId, { sku_id: sId, row_index: item.row_index }));
                } else if (item.sku_id !== undefined) {
                    if (Array.isArray(item.sku_id)) {
                        skuIds.push(...item.sku_id);
                    } else {
                        skuIds.push(item.sku_id);
                    }
                }
            }
        }
    }

    const requests = [...specificRowRequests];

    if (addonSkuIds.length > 0 && skuIds.length > 0) {
        requests.push(sendSingleDelete(invoiceId, { addon_sku_id: addonSkuIds }));
        requests.push(sendSingleDelete(invoiceId, { sku_id: skuIds }));
    } else if (addonSkuIds.length > 0) {
        requests.push(sendSingleDelete(invoiceId, { addon_sku_id: addonSkuIds }));
    } else if (skuIds.length > 0) {
        requests.push(sendSingleDelete(invoiceId, { sku_id: skuIds }));
    }

    if (requests.length === 0) {
        return sendSingleDelete(invoiceId, payload);
    }

    if (requests.length === 1) {
        return requests[0];
    }

    return Promise.all(requests);
};

export default deleteOcrInvoiceSku;
